// sessionStorage outlives a logout in the same tab and every logout path navigates by SPA, so
// practice- or user-scoped keys use the `myriad:` prefix that `clearScopedSessionStorage` sweeps.
export const DOCK_STORAGE_KEY = 'myriad:dock';
export const BATCH_ELIGIBILITY_PROGRESS_STORAGE_KEY = 'myriad:batch-eligibility-progress';

export const PATIENT_BRANDING_CACHE_KEY = 'patient-branding';
